import { lazy } from 'react';
import type { RouteObject } from 'react-router';
import { RequireAuth } from '@/routes/guards';

// Páginas carregadas sob demanda (cada uma vira um pedaço separado do bundle)
const ValidationPage = lazy(() => import('./pages/Validation'));
const PendingSignaturesPage = lazy(() => import('./pages/PendingSignatures'));
const EncounterDocumentsPage = lazy(() => import('./pages/EncounterDocuments'));

const doctor = (el: React.ReactNode) => <RequireAuth roles={['DOCTOR']}>{el}</RequireAuth>;

/**
 * Documentos clínicos (F-09/F-10): validação pública (farmácia, sem login) e áreas do médico.
 * O catálogo da sala (T-35) é o componente DocumentCatalog, embutido pela sala de atendimento.
 */
const routes: RouteObject[] = [
  { path: '/validar', element: <ValidationPage /> },
  { path: '/validar/:token', element: <ValidationPage /> },
  { path: '/medico/documentos-clinicos', element: doctor(<PendingSignaturesPage />) },
  { path: '/medico/documentos-clinicos/:encounterId', element: doctor(<EncounterDocumentsPage />) },
];
export default routes;
